export default __webpack_public_path__ + "static/Plots0000-e83ef7dbf6f87af092c9b0fd3dcbe162.jpg";